// Mirrors the server's quote calculations (server/src/quotes/quotes.service.ts).
// All amounts are in pence; tax rates are in basis points (2000 = 20%).

export interface QuoteLineInput {
  quantity: number;
  unitPrice: number;
  taxRate?: number | null;
}

export function calculateLineNet(line: QuoteLineInput): number {
  return line.quantity * line.unitPrice;
}

// Tax is rounded per line, like the server. `??` keeps a 0% rate at 0.
export function calculateLineTax(line: QuoteLineInput): number {
  return Math.round((calculateLineNet(line) * (line.taxRate ?? 2000)) / 10000);
}

// Gross line total (net + VAT), matching the server and the view screen.
export function calculateLineTotal(line: QuoteLineInput): number {
  return calculateLineNet(line) + calculateLineTax(line);
}

export function calculateQuoteTotals(lines: QuoteLineInput[]) {
  const subTotal = lines.reduce((sum, l) => sum + calculateLineNet(l), 0);
  const taxAmount = lines.reduce((sum, l) => sum + calculateLineTax(l), 0);
  return { subTotal, taxAmount, total: subTotal + taxAmount };
}
